import initializeMobileMenu from './menu';
import initializeFiles from './blocks/files';
import initializeFancyBox from './fancybox';
import initializeForm from './utils/form';
import initializeLazyYoutube from "./utils/lazy-youtube";
import initializeHeader from "./utils/header";
import initializePagination from './utils/pagination';
import initializeSortCountLoaders from './utils/sort_count';

import blockLogotypes from './blocks/logotypes';
import initializeHomeSlider from "./blocks/home-slider";
import blockWooCategoriesIco from './blocks/woo-categories-ico';
import initializeWooSidebarCategories from "./blocks/woo-sidebar-categories";
import initializeBoxSlider from "./blocks/box-slider";

// import initializeAccordions from "./blocks/accordion";
// import initializeIconBoxes from './blocks/icon-boxes';
// import initializeNumbersBlock from './blocks/numbers';
// import initializeGallerySection from './blocks/gallery-section';
// import initializeGalleryGrid from "./blocks/gallery-grid";
// import initializeBrands from './blocks/brands';
// import initializeGallerySlider from './blocks/gallery-slider';
// import initializeGalleryText from './blocks/gallery-text';
// import initializeIconBoxesAnimation from './blocks/icon-boxes-animation';
import WooCommerce from './woo'

class App {
    constructor() {
        this.initialize();
    }

    initialize() {
        import('aos/dist/aos.js').then(({ default: AOS }) => {
            AOS.init({
                startEvent: 'load',
                disable: 'mobile',
                once: true,
                duration: 1000
            });
        });
        initializeHeader();
        initializeForm();
        initializePagination();
        initializeSortCountLoaders();
        initializeFancyBox();
        initializeMobileMenu();
        initializeFiles();
        initializeLazyYoutube();
        blockLogotypes();
        initializeHomeSlider();
        blockWooCategoriesIco();
        initializeWooSidebarCategories();
        initializeBoxSlider();
        // initializeAccordions();
        // initializeCollapse();
        // initializeIconBoxes();
        // initializeNumbersBlock();
        // initializeGallerySection();
        // initializeGalleryGrid();
        // initializeBrands();
        // initializeGallerySlider();
        // initializeGalleryText();
        // initializeIconBoxesAnimation();

        const Woo = new WooCommerce();
    }
}

function initializeApp() {
    const app = new App();
}

if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initializeApp);
} else {
    initializeApp();
}


